<div class="flex items-center justify-center">
  <div>
    <div class="flex items-center justify-center">
      <img class="max-w-48 pt-4" src="assets/images/logo/ts-logo-name.svg" alt="TermSheet logo" />
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
